import type { DeleteScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type DeleteScimDomainInput = { domain: string };

const mapTrpcResponseToGraphQL = (trpcData: {
  updatedDomains: { domain: string; createdOn: string }[];
}): DeleteScimDomainMutation => ({
  delete_scim_domain: {
    __typename: 'DeleteScimDomainOutput',
    updatedDomains: trpcData.updatedDomains.map((d) => ({
      __typename: 'ScimDomainOutput',
      domain: d.domain,
      createdOn: d.createdOn,
    })),
  },
});

export const useDeleteScimDomainTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.scim.deleteDomain.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.scim.getConfig.queryKey(),
        });
      },
    }),
  });

  return {
    deleteScimDomain: async (
      variables: DeleteScimDomainInput
    ): Promise<DeleteScimDomainMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
